export const PARTNER_NAME = {
    SCHUFA: "schufa",
    KFW: "kfw",
};
export const PARTNER_TYPE = {
    priceLink: "priceLink",
    priceModal: "priceModal",
};
export const FINANCIAL_LINK_PARTNER = {
    CA: "CA",
    KFW: "KFW",
    PRETTO: "PRETTO",
    CM: "CM",
    MEDICIS: "MEDICIS",
    NEXTORIES_RESERVEZ: "NEXTORIES_RESERVEZ",
    NEXTORIES_COMPAREZ: "NEXTORIES_COMPAREZ",
};
